<template>
  <div class="animated fadeIn">

    <b-row>

      <b-col sm="12">
        <b-card>

          <form @submit.stop.prevent="onSubmit">

            <b-row>
              <b-col sm="6">
                <b-form-group>
                  <label for="reference">Claim Reference</label>
                  <b-form-input type="text" id="reference" v-model="reference" placeholder="Claim reference" name="reference"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="customer_name">Customer Name</label>
                  <b-form-input type="text" id="customer_name" v-model="customer_name" placeholder="Customer name" name="customer_name"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="date_of_birth">Customer Date Of Birth</label>
                  <b-form-input type="text" id="date_of_birth" v-model="date_of_birth" placeholder="Customer Date Of Birth" name="date_of_birth"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="vet_name">Vet Name</label>
                  <b-form-input type="text" id="vet_name" v-model="vet_name" placeholder="Vet name" name="vet_name"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="pet_name">Pet Name</label>
                  <b-form-input type="text" id="pet_name" v-model="pet_name" placeholder="Pet name" name="pet_name"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="status">Status</label>
                  <b-form-select v-model="status" :options="formoptions.statuses"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="claim_type">Claim Type</label>
                  <b-form-select v-model="claim_type" :options="formoptions.claim_types"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="policy_reference">Policy Reference</label>
                  <b-form-input type="text" id="policy_reference" v-model="policy_reference" placeholder="Policy reference" name="policy_reference"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <div slot="footer">
              <b-button :to="{ name: 'Search' }" size="md" variant="outline-secondary" class="pull-left">
                Back
              </b-button>
              <b-button type="submit" size="md" variant="primary" class="pull-right">
                Submit
              </b-button>
            </div>

          </form>

        </b-card>

      </b-col>

    </b-row>

    <v-server-table :columns="columns" :data="data" :options="options" :theme="theme" id="dataTable" class="table" ref="table" v-show="show">

      <template slot="actions" slot-scope="props">
        <b-button variant="secondary" :to="{ name: 'Claim', params: { id: props.row.id } }">View</b-button>
      </template>

    </v-server-table>

  </div>
</template>

<script>
import Vue from 'vue'
import {ServerTable} from 'vue-tables-2'
import axios from '../../../shared/axios/auth'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import {mask} from 'vue-the-mask'

Vue.use(ServerTable)

export default {
  components: {
    ServerTable
  },
  props: {
    policy_reference: {
      type: String,
      required: false,
    },
    customer_id: {
      type: Number,
      required: false,
    },
  },
  directives: {mask},
  mixins: [validationMixin],
  data () {
    return {
      show: false,
      search: this.$route.params.search,
      searchselected: null,
      reference: null,
      customer_name: null,
      date_of_birth: null,
      vet_name: null,
      pet_name: null,
      status: null,
      claim_type: null,
      //policy_reference: (this.$props.policy_reference ? this.$props.policy_reference : null),
      formoptions: {
        claim_types: [{'value': null, 'text': 'Please select'}, {'value': 1, 'text': 'New Claim'}, {'value': 2, 'text': 'Continuation Claim'}],
        statuses: [{'value': null, 'text': 'Please select'}, {'value': 1, 'text': 'Submitted'}, {'value': 2, 'text': 'Processing'}, {'value': 3, 'text': 'Awaiting Policy holder information'}, {'value': 4, 'text': 'Awaiting Policy holder documentation'}, {'value': 5, 'text': 'Awaiting Vet information'}, {'value': 6, 'text': 'Awaiting Vet documentation'}, {'value': 7, 'text': 'Awaiting Approval'}, {'value': 8, 'text': 'Under Review'}, {'value': 9, 'text': 'Declined'}, {'value': 10, 'text': 'Settled/Paid'}, {'value': 11, 'text': 'Awaiting Review'}]
      },
      // Data Table
      columns: [
          'claim_number', 'claim_type', 'claim_sub_type', 'vet_name', 'status', 'actions'
      ],
      data: [],
      fields: [
      ],
      options: {
        requestFunction: (data) => {
          let new_params  = {};
          let n_params = {
            product: localStorage.getItem('selected_product'),
            filter: this.searchselected

          };
          let params_ = {}
          if (this.reference) {
            params_.reference = this.reference
          }
          if (this.customer_name) {
            params_.customer_name = this.customer_name
          }
          if (this.customer_id) {
            params_.customer_id = this.customer_id
          }
          if (this.date_of_birth) {
            params_.dob = this.date_of_birth
          }
          if (this.pet_name) {
            params_.pet = this.pet_name
          }
          if (this.vet_name) {
            params_.vet_name = this.vet_name
          }
          if (this.status) {
            params_.status = this.status
          }
          if (this.claim_type) {
            params_.claim_type = this.claim_type
          }
          if (this.policy_reference) {
            params_.policy_reference = this.policy_reference
          }
          if (this.created_date) {
            let dob_string = this.created_date;
            let split_dob = dob_string.split("/")

            let day = split_dob[0]
            let month = split_dob[1]
            let year = split_dob[2]

            params_.created_date = year + '-' + month + '-' + day
          }

          new_params = Object.assign({}, params_, data, n_params)

          return axios.get('/claims/search/', {
              params: new_params
          }).catch(error => {
              // Unauthorised
              if (error.response.status === 401) {
                this.$store.dispatch('logout');
              }
              console.log('post error');
              console.log(error.response);
          });
        },
        responseAdapter: function(resp) {
          console.log('adapter');
          var data = this.getResponseData(resp);
          if(this.$parent.customer_id){
            try {
              this.$parent.customer_name = data.data.data[0].customer_name;
              this.$parent.date_of_birth = data.data.data[0].customer_dob;
            } catch(e){}
          }
          this.show = 'true'
          return { data: data.data.data, count: data.data.pagination.total }
        },
        headings: {},
        sortable: [],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        filterable: false
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default'
    }
  },
  validations: {
  },
  methods: {
      validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      },
    onSubmit () {
        //this.showAPIError = false;
        this.$v.$touch();
        if (this.$v.$anyError) {
          return;
        }

        let search_params = '';
        if (this.reference) {
          search_params += 'reference=' + this.reference
        }
        if (this.customer_name) {
            if (search_params) {
              search_params += '&customer_name=' + this.customer_name
            } else {
              search_params += 'customer_name=' + this.customer_name
            }
        }
        if (this.customer_id) {
            if (search_params) {
              search_params += '&customer_id=' + this.customer_id
            } else {
              search_params += 'customer_id=' + this.customer_id
            }
        }
        if (this.date_of_birth) {
            if (search_params) {
              search_params += '&dob=' + this.date_of_birth
            } else {
              search_params += 'dob=' + this.date_of_birth
            }
        }
        if (this.vet_name) {
            if (search_params) {
              search_params += '&vet_name=' + this.vet_name
            } else {
              search_params += 'vet_name=' + this.vet_name
            }
        }
        if (this.pet_name) {
            if (search_params) {
              search_params += '&pet_name=' + this.pet_name
            } else {
              search_params += 'pet_name=' + this.pet_name
            }
        }
        if (this.status) {
            if (search_params) {
              search_params += '&status=' + this.status
            } else {
              search_params += 'status=' + this.status
            }
        }
        if (this.claim_type) {
            if (search_params) {
              search_params += '&claim_type=' + this.claim_type
            } else {
              search_params += 'claim_type=' + this.claim_type
            }
        }
        if (this.policy_reference) {
            if (search_params) {
              search_params += '&policy_reference=' + this.policy_reference
            } else {
              search_params += 'policy_reference=' + this.policy_reference
            }
        }
        if (this.created_date) {
            if (search_params) {
              search_params += '&created_date=' + this.created_date
            } else {
              search_params += 'created_date=' + this.created_date
            }
        }

        this.$refs.table.refresh();
        this.show = 'true'

        /*axios.get('/claims/search/?' + search_params).then(res => {
          this.data = res.data
          this.$refs.table.refresh();
          this.show = 'true'

        }).catch(error => {
            // Unauthorised
            if (error.response.status === 401) {
              this.$store.dispatch('logout');
            }
              console.log('post error');
              console.log(error);
          })*/
    }
  },
  mounted(){
    if(this.policy_reference || this.customer_id){
      //this.onSubmit();
      this.show = 'true'
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
